import type LanguageCode from "../entities/languageCode";
import type SystemComponentOutageLocalizationRequest from "../entities/systemComponentOutageLocalizationRequest";

type GetCustomOutageProps = {
  languageCode: LanguageCode;
  localizations?: SystemComponentOutageLocalizationRequest[];
};

type SetCustomOutageProps = GetCustomOutageProps & {
  description: string;
};

export const setCustomOutage = ({ description, languageCode, localizations }: SetCustomOutageProps) => {
  let otherTranslations: SystemComponentOutageLocalizationRequest[] = [];
  if (localizations && localizations.length > 0) {
    otherTranslations = localizations.filter(outage => outage.languageCode !== languageCode);
  }

  return [
    {
      languageCode,
      description,
    },
    ...otherTranslations,
  ];
};

export const getCustomOutage = ({ languageCode, localizations }: GetCustomOutageProps) => {
  const outage = localizations?.find(outage => outage.languageCode === languageCode);
  return outage?.description ?? "";
};
